import { analyticsApiClient } from "@api/analytics-api-client";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { buildDateRangeQuery } from "@components/analytics/in-house/utils/analytics-utils";
import { createAsyncThunk } from "@reduxjs/toolkit";
/**
 * Fetches stats from the backend to show analytics
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const fetchCompanyStats = createAsyncThunk("groups/fetchCompanyStats", async ({
  companyId
}, thunkAPI) => {
  const state = thunkAPI.getState();
  // Caches the response of the stats not to always fetch them from the backend
  if (state.analytics.companyStats) {
    return state.analytics.companyStats;
  }
  return await faroCoreApiClient.company.getCompanyStatistics({
    companyId
  });
});
/**
 * Fetches stats from the backend for a single project to show analytics
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const fetchProjectStats = createAsyncThunk("groups/fetchProjectStats", async ({
  companyId,
  projectId
}, thunkAPI) => {
  const state = thunkAPI.getState();
  // Caches the response of the stats not to always fetch them from the backend
  if (state.analytics.projectStats[projectId]) {
    return {
      projectId,
      stats: state.analytics.projectStats[projectId]
    };
  }
  const response = await faroCoreApiClient.projects.getProjectStatistics({
    companyId,
    projectId
  });
  return {
    projectId,
    stats: response
  };
});
/**
 * Fetches the in-house analytics dashboard summary that powers the KPI bar.
 * @throws {HttpUtils.FetchError} if the Analytics API client request fails
 */
export const fetchInHouseAnalyticsDashboard = createAsyncThunk("analytics/fetchInHouseAnalyticsDashboard", async ({
  companyId,
  selectedRange
}) => {
  const response = await analyticsApiClient.analytics.getDashboard({
    workspaceId: companyId,
    shouldUseMock: true,
    query: buildDateRangeQuery(selectedRange)
  });

  // TODO: Remove console https://faro01.atlassian.net/browse/ST-4728
  // eslint-disable-next-line no-console -- Logging for testers based on PR comments
  console.log("analytics dashboard response", response);
  return response.summary ?? null;
});